import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React, { useRef } from "react";
import { find } from "lodash";

import MainNavLink from "~/components/links/MainNavLink";
import LanguageSubnav from "~/components/LanguageSubnav";

import useOnClickOutside from "~/hooks/useOnClickOutside";
import { useTranslationContext } from "~/context/TranslationContext";

const OuterWrapper = styled.div`
    display: block;
    border: 1px solid ${({ theme }) => theme.palette.grayFour};
    border-radius: 6px;
    padding: 4px 8px;
    position: relative;

    @media (max-width: ${({ theme }) => theme.breakpoints.desktopMax}) {
        display: none;
    }
`;

const LanguageWrapper = styled.div`
    display: flex;
`;

const useLanguageLabel = (links) => {
    const { activeCode } = useTranslationContext();
    const label = find(links, { languageCode: activeCode });
    if (label) {
        return label;
    }
    return {
        linkLabel: "English",
    };
};

const LanguageDropdown = ({ dispatch, openedSubnavs = {}, links }) => {
    const ref = useRef();
    const { linkLabel, linkNativeName, linkTranslatedName, languageCode } =
        useLanguageLabel(links);
    const isOpen = openedSubnavs.secondary === `${linkLabel}-0`;

    useOnClickOutside(ref, () => {
        if (isOpen) {
            dispatch({ type: "HANDLE_CLICK_OUTSIDE" });
        }
    });

    return (
        <OuterWrapper>
            <LanguageWrapper
                onClick={() => {
                    dispatch({
                        type: "HANDLE_SUB_NAV",
                        id: `${linkLabel}-0`,
                        currentSubNavs: openedSubnavs,
                        level: "secondary",
                    });
                }}
                {...{ ref }}
            >
                <MainNavLink
                    hasDropdown={true}
                    index={0}
                    {...{
                        linkLabel,
                        linkNativeName,
                        linkTranslatedName,
                        languageCode,
                    }}
                    isNavOpened={isOpen}
                    icon="globe"
                    tagRef={null}
                    screenReaderText="Language: "
                />
                <LanguageSubnav
                    items={links}
                    topLinkLabel={linkNativeName ?? linkLabel}
                    {...{ dispatch, isOpen }}
                />
            </LanguageWrapper>
        </OuterWrapper>
    );
};

LanguageDropdown.propTypes = {
    dispatch: PropTypes.func.isRequired,
    openedSubnavs: PropTypes.shape({}),
    links: PropTypes.arrayOf(
        PropTypes.shape({
            linkLabel: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.object,
            ]),
            linkNativeName: PropTypes.string,
            linkTranslatedName: PropTypes.string,
            languageCode: PropTypes.string,
            linkUrl: PropTypes.string.isRequired,
        }),
    ).isRequired,
};

export default LanguageDropdown;
